import { ExperimentGroupingStatus } from '../../types/emsData'

export type StatusParams = {
    archived?: boolean
    live?: boolean
    startDateAfter?: string
    endDateBefore?: string
    startDateBefore?: string
    endDateAfter?: string
}

export const mapStatusToSearchParameters = (status: ExperimentGroupingStatus): StatusParams => {
    switch (status) {
        case ExperimentGroupingStatus.ARCHIVED: {
            return {
                archived: true,
                live: false,
            }
        }
        case ExperimentGroupingStatus.PAUSED: {
            return {
                archived: false,
                live: false,
                endDateAfter: new Date().toISOString(),
            }
        }
        case ExperimentGroupingStatus.CONCLUDED: {
            return {
                endDateBefore: new Date().toISOString(),
                live: false,
                archived: false,
            }
        }
        case ExperimentGroupingStatus.SCHEDULED: {
            return {
                startDateAfter: new Date().toISOString(),
                live: true,
            }
        }
        case ExperimentGroupingStatus.LIVE: {
            return {
                live: true,
                startDateBefore: new Date().toISOString(),
                endDateAfter: new Date().toISOString(),
            }
        }
        default:
            return {}
    }
}
